import { createReducer } from 'typesafe-actions';
import { tabAIAction, tabAIState } from './types';

import {
  GET_PATH_NETWORK_RECOMMEND,
  GET_PATH_NETWORK_RECOMMEND_ERROR,
  GET_PATH_NETWORK_RECOMMEND_SUCCESS,
  GET_PATENT,
  GET_PATENT_SUCCESS,
  GET_PATENT_ERROR,
  GET_RECOMMENDED_WORD,
  GET_RECOMMENDED_WORD_ERROR,
  GET_RECOMMENDED_WORD_SUCCESS,
  SET_IS_MORE_INFO_PATH_0,
  SET_IS_MORE_INFO_PATH_1,
  SET_IS_MORE_INFO_PATH_2,
  GET_PATH_NETWORK_RECOMMEND2,
  GET_PATH_NETWORK_RECOMMEND2_SUCCESS,
  GET_PATH_NETWORK_RECOMMEND2_ERROR,
  SET_IS_MORE_INFO_PATH_ATTACH_0,
  SET_IS_MORE_INFO_PATH_ATTACH_1,
  SET_IS_MORE_INFO_PATH_ATTACH_2,
  SET_AI_DATA_NULL,
} from './actions';

const initialState: tabAIState = {
  error: null,
  loading: false,
  data: null,
  recommend_path: [],
  total_counts: [],
  network_data: null,
  result: [],
  patentData: { patent: '', related_patent: [] },
  recommendedWord: [],
  isMoreInfoPath0: false,
  isMoreInfoPath1: false,
  isMoreInfoPath2: false,
  isMoreInfoPathAttach0: false,
  isMoreInfoPathAttach1: false,
  isMoreInfoPathAttach2: false,

  crawler_data_ai_results: [],
  crawler_data_ai_recommend_path: [],
  crawler_data_ai_network_data: { nodes: [], edge: [] },
  crawler_data_ai_total_counts: [],
};

const reducer = createReducer<tabAIState, tabAIAction>(initialState, {
  [GET_PATH_NETWORK_RECOMMEND]: (state) => ({
    ...state,
    error: null,
    // loading: true,
    data: null,
    network_data: null,
    result: [],
    recommend_path: [],
    total_counts: [],
  }),
  [GET_PATH_NETWORK_RECOMMEND_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    // loading: false,
    data: action.payload,
    recommend_path: action.payload.payload.recommend_path,
    total_counts: action.payload.payload.total_counts,
    network_data: action.payload.payload.network_data,
    result: action.payload.payload.results,
  }),
  [GET_PATH_NETWORK_RECOMMEND_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    // loading: false,
    data: null,
  }),

  [GET_PATH_NETWORK_RECOMMEND2]: (state) => ({
    ...state,
    error: null,
    loading: true,

    crawler_data_ai_results: [],
    crawler_data_ai_recommend_path: [],
    crawler_data_ai_network_data: { nodes: [], edge: [] },
    crawler_data_ai_total_counts: [],
  }),
  [GET_PATH_NETWORK_RECOMMEND2_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    loading: false,

    crawler_data_ai_results: action.payload.payload.results,
    crawler_data_ai_recommend_path: action.payload.payload.recommend_path,
    crawler_data_ai_network_data: action.payload.payload.network_data,
    crawler_data_ai_total_counts: action.payload.payload.total_counts,
  }),
  [GET_PATH_NETWORK_RECOMMEND2_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    loading: false,

    crawler_data_ai_results: [],
    crawler_data_ai_recommend_path: [],
    crawler_data_ai_network_data: { nodes: [], edge: [] },
    crawler_data_ai_total_counts: [],
  }),
  [SET_AI_DATA_NULL]: (state) => ({
    ...state,
    loading: true,
    crawler_data_ai_results: [],
    crawler_data_ai_recommend_path: [],
    crawler_data_ai_network_data: { nodes: [], edge: [] },
    crawler_data_ai_total_counts: [],
  }),

  [GET_PATENT]: (state) => ({
    ...state,
    error: null,
    // loading: true,
    patentData: { patent: '', related_patent: [] },
  }),
  [GET_PATENT_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    // loading: false,
    patentData: action.payload.payload.payload,
  }),
  [GET_PATENT_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    // loading: false,
    patentData: { patent: '', related_patent: [] },
  }),

  [GET_RECOMMENDED_WORD]: (state) => ({
    ...state,
    error: null,
    // loading: true,
    recommendedWord: [],
  }),
  [GET_RECOMMENDED_WORD_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    // loading: false,
    recommendedWord: action.payload.payload,
  }),
  [GET_RECOMMENDED_WORD_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    // loading: false,
    recommendedWord: [],
  }),
  [SET_IS_MORE_INFO_PATH_0]: (state, action) => ({
    ...state,
    isMoreInfoPath0: action.payload,
  }),
  [SET_IS_MORE_INFO_PATH_1]: (state, action) => ({
    ...state,
    isMoreInfoPath1: action.payload,
  }),
  [SET_IS_MORE_INFO_PATH_2]: (state, action) => ({
    ...state,
    isMoreInfoPath2: action.payload,
  }),

  [SET_IS_MORE_INFO_PATH_ATTACH_0]: (state, action) => ({
    ...state,
    isMoreInfoPathAttach0: action.payload,
  }),
  [SET_IS_MORE_INFO_PATH_ATTACH_1]: (state, action) => ({
    ...state,
    isMoreInfoPathAttach1: action.payload,
  }),
  [SET_IS_MORE_INFO_PATH_ATTACH_2]: (state, action) => ({
    ...state,
    isMoreInfoPathAttach2: action.payload,
  }),
});

export default reducer;
